import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import ValidationError from 'components/consumer/ValidationError';
import ConsumerLoginSideBarLink from '../ConsumerLoginSideBarLink';
const INITIAL_VALUES = {
  order_id: '',
  zip: ''
};
const formSchema = Yup.object().shape({
  order_id: Yup.string().required('Order number is required').matches(/((^(J|j{1})(-{1})([0-9]{1,})$)|(^[0-9]{1,}$))/, 'Invalid order number'),
  zip: Yup.string().required('Billing zip code is required').max(10, 'Invalid billing zip code')
});
const TrackOrderStatusForm = t0 => {
  const $ = _c(7);
  const {
    state,
    actions
  } = t0;
  let t1;
  if ($[0] !== actions || $[1] !== state.errMsg || $[2] !== state.isLoading) {
    t1 = t2 => {
      const {
        values,
        errors,
        touched,
        handleSubmit,
        handleBlur,
        setFieldValue
      } = t2;
      return <div className="mx-auto my-4 p-4 max-w-[30rem] bg-white rounded-[.5rem] max-[1023px]:max-w-[25rem] max-[767px]:max-w-[30rem] [&_button]:w-full [&_button]:mt-8"><div className="text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold text-gray">Track Your Order</div><form data-xc="track-order-status-form" onSubmit={handleSubmit}><div className="track-order-status-fields"><div className="track-order-status-form__field"><div className="track-order-status-form__field"><LabeledTextInput type="text" name="order_id" value={values.order_id} label="Order Number" placeholder="Order Number" onBlur={handleBlur} errorMessage={errors.order_id && touched.order_id ? errors.order_id : ""} required={true} onChange={evt => {
                  const val = evt.target.value;
                  setFieldValue("order_id", val ? val.replace(/[^0-9]/g, "") : "");
                  actions.resetError();
                }} data-xc="tracking-order_id-field" /></div></div><div className="track-order-status-form__field"><LabeledTextInput type="text" name="zip" value={values.zip} label="Billing zip code" placeholder="Billing zip code" onBlur={handleBlur} onChange={evt_0 => {
                actions.resetError();
                setFieldValue("zip", evt_0.target.value);
              }} errorMessage={errors.zip && touched.zip ? errors.zip : ""} required={true} /></div></div>{!!state.errMsg && <ValidationError data-xc="track-order-status-form-validation" block={true} className="!px-[.9em] !py-[.55em] !mx-[.5em] !my-[.95em] !border !border-solid ![border-color:#d00] ![background:#ffebe8] !text-[.955em]">{state.errMsg}</ValidationError>}<CtaButton type="submit" color="black" noLinkPadding={true} hasArrow={false} styling="solid-button" data-xc="issue-submit-btn" disabled={state.isLoading} isLoading={state.isLoading}>Track Your Order</CtaButton></form><div className="[background:none] h-[34px] relative text-center mt-[1.375rem] [&_hr]:border-0 [&_hr]:[border-top:1px_solid_#e5e5e5] [&_hr]:-mt-4 [&_hr]:mx-auto [&_hr]:mb-2.5 [&_hr]:w-full"><span className="bg-white inline-block p-2 text-[.9rem] font-bold text-gray">or</span><hr aria-hidden="true" /></div><div className="text-center pb-6"><ConsumerLoginSideBarLink /></div></div>;
    };
    $[0] = actions;
    $[1] = state.errMsg;
    $[2] = state.isLoading;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== actions.formSubmitHandle || $[5] !== t1) {
    t2 = <Formik name="trackOrderStatusForm" initialValues={INITIAL_VALUES} validationSchema={formSchema} validateOnBlur={true} onSubmit={actions.formSubmitHandle} render={t1} />;
    $[4] = actions.formSubmitHandle;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
TrackOrderStatusForm.propTypes = {
  state: PropTypes.shape({
    errMsg: PropTypes.string,
    isLoading: PropTypes.bool
  }),
  actions: PropTypes.shape({
    formSubmitHandle: PropTypes.func,
    resetError: PropTypes.func
  })
};
export default TrackOrderStatusForm;